import { de } from './de-strings';
import { en } from './en-strings';

export const translations = { de, en };